import React, { useState } from 'react';
import { useDrop } from 'react-dnd';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

import { addData, reset } from '../../../../../_actions/document-builder.actions'

import PageBreak from './DocumentCanvasComponent/PageBreak';
import Header from './DocumentCanvasComponent/Header';
import Question from './DocumentCanvasComponent/Question';
import FirstName from './DocumentCanvasComponent/FirstName';
import LastName from './DocumentCanvasComponent/LastName';
import DateOfBirth from './DocumentCanvasComponent/DateOfBirth';
import Gender from './DocumentCanvasComponent/Gender';
import Height from './DocumentCanvasComponent/Height';
import Weight from './DocumentCanvasComponent/Weight';
import Race from './DocumentCanvasComponent/Race';
import Ethnicity from './DocumentCanvasComponent/Ethnicity';
import PreferredLanguage from './DocumentCanvasComponent/PreferredLanguage';
import Allergies from './DocumentCanvasComponent/Allergies';
import Medications from './DocumentCanvasComponent/Medications';
import TreatmentPlan from './DocumentCanvasComponent/TreatmentPlan';
import PhysicalExam from './DocumentCanvasComponent/PhysicalExam';
import StudiesImaging from './DocumentCanvasComponent/StudiesImaging';
import Dialogue from './DocumentCanvasComponent/Dialogue';
import HPI from './DocumentCanvasComponent/HPI';
import Diagnosis from './DocumentCanvasComponent/Diagnosis';
import AppointmentDetails from './DocumentCanvasComponent/AppointmentDetails';

const acceptTypes = ['header', 'question', 'first_name', 'last_name', 'date_of_birth',
  'gender', 'height', 'weight', 'race', 'ethnicity', 'preferred_language',
  'allergies', 'medications', 'treatment_plan', 'physical_exam',
  'studies_imaging', 'dialogue', 'hpi', 'diagnosis', 'page_break', 'appointment_details'];

function DocumentCanvas({ item, dispatch }) {
  const [show, setShow] = useState(false);

  const handleClose = () => { setShow(false); }
  const handleShow = () => { setShow(true); }

  const [{ canDrop }, drop] = useDrop({
    accept: acceptTypes,
    drop: (item, monitor) => {
      if (monitor.didDrop()) {
        return;
      }

      dispatch(addData(item));
    },
    collect: (monitor) => ({
      canDrop: monitor.canDrop() && monitor.isOver({ shallow: true }),
    })
  });

  const style = classNames('document-canvas', 'p-3', {
    active: canDrop
  });

  return <>
    <div className="col mb-2">
      <h5 style={{ borderBottom: '4px solid #1AB2E9' }}>Document Canvas</h5>
    </div>

    <div ref={drop} className={style}>
      <div className="row">
        <div className="col">
          <img src="https://via.placeholder.com/250x125?text=Your Logo" className="rounded mx-auto d-block" alt="Logo" />
        </div>
        <div className="col">
          <h5 className="text-center lead mt-3">
            1234 Example St. Suite A <br />
            FooBar, CA 924710 <br />
            (909) 558-1600
          </h5>
        </div>

        <div className="col-12 mt-4">
          <div className="row">
            <div className="col">
              <p className="m-0"><strong>Chart ID:</strong> 999999</p>
              <p className="m-0"><strong>Patient Name:</strong> Jane Doe</p>
              <p className="m-0"><strong>Date of Birth:</strong> 10/25/1976</p>
            </div>
            <div className="col">
              <p className="m-0"><strong>Appointment Date:</strong> 07/07/2020</p>
              <p className="m-0"><strong>Provider:</strong> Dr. Trevor Wang (example)</p>
              <p className="m-0"><strong>Location:</strong> Spine Center</p>
            </div>
          </div>
        </div>
      </div>

      <div className="document-dropzone">
        {item.length === 0 &&
          <div className="empty mt-3">
            <h5>Start building your document!</h5>
            <p>Drag data from the left panels.</p>
          </div>
        }

        {item.length > 0 && item.map((itemType, index) => {
          switch (itemType.type) {
            case 'appointment_details':
              return <AppointmentDetails key={itemType.position} index={index} item={itemType} />;
            case 'page_break':
              return <PageBreak key={itemType.position} index={index} item={itemType} />;
            case 'header':
              return <Header key={itemType.position} index={index} item={itemType} />;
            case 'question':
              return <Question key={itemType.position} index={index} item={itemType} />;
            case 'first_name':
              return <FirstName key={itemType.position} index={index} item={itemType} />;
            case 'last_name':
              return <LastName key={itemType.position} index={index} item={itemType} />;
            case 'date_of_birth':
              return <DateOfBirth key={itemType.position} index={index} item={itemType} />;
            case 'gender':
              return <Gender key={itemType.position} index={index} item={itemType} />;
            case 'height':
              return <Height key={itemType.position} index={index} item={itemType} />;
            case 'weight':
              return <Weight key={itemType.position} index={index} item={itemType} />;
            case 'race':
              return <Race key={itemType.position} index={index} item={itemType} />;
            case 'ethnicity':
              return <Ethnicity key={itemType.position} index={index} item={itemType} />;
            case 'preferred_language':
              return <PreferredLanguage key={itemType.position} index={index} item={itemType} />;
            case 'allergies':
              return <Allergies key={itemType.position} index={index} item={itemType} />;
            case 'medications':
              return <Medications key={itemType.position} index={index} item={itemType} />;
            case 'diagnosis':
              return <Diagnosis key={itemType.position} index={index} item={itemType} />;
            case 'treatment_plan':
              return <TreatmentPlan key={itemType.position} index={index} item={itemType} />;
            case 'physical_exam':
              return <PhysicalExam key={itemType.position} index={index} item={itemType} />;
            case 'studies_imaging':
              return <StudiesImaging key={itemType.position} index={index} item={itemType} />;
            case 'dialogue':
              return <Dialogue key={itemType.position} index={index} item={itemType} />;
            case 'hpi':
              return <HPI key={itemType.position} index={index} item={itemType} />;
            default:
              return null;
          }
        })}
      </div>
    </div>

    <button onClick={handleShow} type="button" className="btn btn-outline-primary mt-2">Clear Canvas</button>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Clear Canvas</Modal.Title>
      </Modal.Header>

      <Modal.Body>Are you sure you want to clear the canvas?</Modal.Body>

      <Modal.Footer>
        <Button onClick={() => {
          dispatch(reset());
          handleClose();
        }}
          variant="primary">Clear Canvas</Button>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

const mapStateToProps = state => {
  return {
    item: state.documentBuilder.current.item
  }
}

export default connect(mapStateToProps)(DocumentCanvas);